<template>
  <div class="text-body-2">
    <h-menu-chips />
    <v-row no-gutters justify="space-between" align="center">
      <v-col>
        <h-menu-hints />
      </v-col>
      <h-fast-menu-quantity
        v-if="config('fastMenuEntry')"
        @change="$emit('change')"
      />
    </v-row>
  </div>
</template>

<script>
  import Configurable from '@/Mixins/Configurable'
  import HMenuChips from './Chips'
  import HMenuHints from './Hints'
  import HFastMenuQuantity from './FastQuantity'

  export default {
    mixins: [
      Configurable,
    ],

    components: {
      HMenuChips,
      HMenuHints,
      HFastMenuQuantity,
    },
  }
</script>
